
document.addEventListener('DOMContentLoaded', () => {
  $('[data-bs-toggle="tooltip"]').tooltip();
});

